import { render, staticRenderFns } from "./AddDeductionModal.vue?vue&type=template&id=35ae44f5&scoped=true&"
import script from "./AddDeductionModal.vue?vue&type=script&lang=js&"
export * from "./AddDeductionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDeductionModal.vue?vue&type=style&index=0&id=35ae44f5&scoped=true&lang=scss&"
import style1 from "./AddDeductionModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae44f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ae44f5')) {
      api.createRecord('35ae44f5', component.options)
    } else {
      api.reload('35ae44f5', component.options)
    }
    module.hot.accept("./AddDeductionModal.vue?vue&type=template&id=35ae44f5&scoped=true&", function () {
      api.rerender('35ae44f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/AddDeductionModal.vue"
export default component.exports